<template>
  <div>
    <sys-data-table
      :headers="headers"
      :items="desserts"
      fixed-header
      hide-default-footer
      :item-height="25"
      :height="alturaDaJanela - 150"
      class="table-full-screen font-resp-tabela"
    >
      <template v-slot:item.preco="{ value }">
        R$ {{ Helpers.formatarValorComCasas(value, 2) }}
      </template>

    </sys-data-table>
  </div>
</template>

<script>
import Responsive from '@/helpers/ResponsiveHeight';

export default {
  mixins: [Responsive],
  props: {
    itens_expandidos: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      headers: [
        { text: 'Id Produto', value: 'idproduto' },
        { text: 'Cod. Produto', value: 'cod_produto' },
        { text: 'Cod. Barras', value: 'codigo_barras' },
        { text: 'Descrição Produto', value: 'descricao_produto' },
        { text: 'Preço', value: 'preco' },
      ],
      desserts: []
    }
  },
  watch: {
    itens_expandidos(valor) {
      this.desserts = valor;
    }
  }
}
</script>

<style>

</style>
